import i18n from '@/utils/i18n';
import React from 'react';
import { BottomTabNavigationOptions } from '@react-navigation/bottom-tabs';
import { NAVIGATION_TAB_LABELS } from '@/utils/navigation';
import { StyleSheet, Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { useTheme } from '@/contexts/theme-context';

type Props = {
  routeName: string;
} & Parameters<
  Exclude<BottomTabNavigationOptions['tabBarLabel'], string | undefined>
>[0];

export const TabBarLabel: React.FC<Props> = ({ focused, routeName }) => {
  const salesRepMode = useSalesRepMode();
  const theme = useTheme();

  const label = NAVIGATION_TAB_LABELS[routeName];
  return (
    <Text
      numberOfLines={1}
      style={[
        TYPOGRAPHY.tiny,
        styles.label,
        {
          color: focused
            ? salesRepMode
              ? theme.colors.white
              : theme.colors.primary
            : theme.colors.inactiveText,
        },
      ]}
    >
      {i18n.t(label)}
    </Text>
  );
};

const styles = StyleSheet.create({
  label: {
    lineHeight: 12,
    textAlign: 'center',
  },
});
